import {
  createPerk,
  deletePerk,
  updatePerk,
} from '@store/membership/PerkReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { langList } from '../../../factories/Utils'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const PerkForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.perk)

  const composeFormData = (values: any): FormData => {
    const data = new FormData()
    const fields = ['id', 'name', 'isFeatured', 'isVisible']

    fields.forEach((field) => {
      const value = values[field]
      if (value === undefined || value === null) {
        return
      }
      data.append(field, value)
    })

    // Localized fields
    langList.forEach((lang) => {
      const value = values[lang.code] ?? {}
      data.append(`${lang.code}[title]`, value.title)
      data.append(`${lang.code}[caption]`, value.caption)
      data.append(`${lang.code}[description]`, value.description)
    })

    if (values.plans) {
      values.plans.forEach((plan: any) => {
        data.append('plans[]', plan)
      })
    }

    if (values.picture && values.picture[0].originFileObj) {
      data.append('picture', values.picture[0].originFileObj)
    }

    return data
  }

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createPerk(composeFormData(values))).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updatePerk(composeFormData(values))).then(() => {
            return true
          }),
        delete: async (values) => {
          return dispatch(deletePerk(values)).then(() => {
            return true
          })
        },
      }}
    />
  )
})

PerkForm.displayName = 'PerkForm'

export default PerkForm
